import {sendAfToken} from '../../site/global/all';

const $userAdmin = $('#userGrid');
let k_userAdmin = null;

export default function () {
    if ($userAdmin.length) {
        k_userAdmin = $userAdmin.data('kendoGrid');
        if (k_userAdmin) {
            // setFilterTemplate();
            setDataSourceData();
            setClientTemplate();
            // setFilters();
            companyList.read();
            k_userAdmin.dataSource.read();
        }
    }
}

// Set Grid Elements
// ===================================================================
const companyList = new kendo.data.DataSource({
    transport: {
        read: {
            url: '/Account/Company/GetJSON', type: 'get', dataType: 'json'
        }
    }
});

/*const yesNoOptions = new kendo.data.DataSource({
    data: [{text: 'Yes', value: true}, {text: 'No', value: false}]
});*/

const setClientTemplate = () => {
    window.getCompanyName = getCompanyName;
};

const getCompanyName = (cid) => {
    if (cid === -1 || cid === undefined) return 'Not assigned in VP';
    const com = companyList.data().find(function (me) {
        if (me.CompanyID === undefined) me.CompanyID = -1;
        return me.CompanyID === cid;
    });
    if (com === undefined) return 'Not in portal';
    return com.CompanyName;
};

const openPermissions = () => {
    let $permissions = $('.k-grid-Permissions');
    if ($permissions.length) {
        $permissions.click(function () {
            let dataItem = k_userAdmin.dataItem($(this).closest('tr'));
            let rolesWindow = $('#editUserRoles').data('kendoWindow');
            rolesWindow.refresh({url: 'EditUserRolesAsync?Id=' + dataItem.id, type: 'POST'});
            rolesWindow.center();
            rolesWindow.open();
        });
    }
};

const openEdit = () => {
    let editable = k_userAdmin.options.editable;
    editable.window.open = function () {
        let pup = this.element;
        let vpOnly = pup.find('#ViewpointOnly').val();
        if (vpOnly === 'true') {
            pup.find('.portal').hide();
        } else {
            pup.find('.viewpoint').hide();
        }
    };

    editable.window.close = function () {
        openPermissions();
    }
};

// Set Grid Events & transport info
// ===================================================================
const setDataSourceData = () => {
    let kendoOptions = k_userAdmin.dataSource.transport.options;
    let k_lastNameFilter = $('[data-text-field=LastName]').data('kendoAutoComplete');
    let k_firstNameFilter = $('[data-text-field=FirstName]').data('kendoAutoComplete');

    if (kendoOptions.read) {
        k_lastNameFilter.dataSource.transport.options.read.data = sendAfToken;
        k_firstNameFilter.dataSource.transport.options.read.data = sendAfToken;
        kendoOptions.read.data = sendAfToken;
    }
    if (kendoOptions.update) {
        kendoOptions.update.data = gridUpdateData;
    }

    k_userAdmin.dataSource._events.change.push(function () {
        openPermissions();
        openEdit();
    });
};

const gridUpdateData = (data, type) => {
    data = sendAfToken(data, type);
    const addVal = {DefaultPassword: $('#UseDefaultPassword').is(':checked')};
    return $.extend(addVal, data);
};
